import { UnsavedChangesDialog } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

export type EntityUnsavedChangesDialogProps = {
    open: boolean;
    busy?: boolean;
    saveDisabled?: boolean;
    onSave: () => void;
    onDiscard: () => void;
    onKeepEditing: () => void;
};

/** Shared FOODS three-action confirmation for dirty entity forms. */
export const EntityUnsavedChangesDialog = (props: EntityUnsavedChangesDialogProps) => {
    const { open, busy, saveDisabled, onSave, onDiscard, onKeepEditing } = props;
    const { t } = useTranslation();

    return (
        <UnsavedChangesDialog
            open={open}
            title={t("entity_form.unsaved_changes.title", "Unsaved changes")}
            description={t(
                "entity_form.unsaved_changes.description",
                "You have unsaved changes. What would you like to do?",
            )}
            saveLabel={t("entity_form.unsaved_changes.save_and_leave", "Save and leave")}
            discardLabel={t("entity_form.unsaved_changes.leave_without_saving", "Leave without saving")}
            keepEditingLabel={t("entity_form.unsaved_changes.keep_editing", "Keep editing")}
            busy={busy}
            saveDisabled={saveDisabled}
            onSave={onSave}
            onDiscard={onDiscard}
            onKeepEditing={onKeepEditing}
        />
    );
};
